import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgRedux, select} from '@angular-redux/store';
import {IAppState} from '../../reducers/root.reducer';
import {Observable, Subject} from 'rxjs';
import {ApiService} from '../../services/api.service';
import {LayerActions} from '../../reducers/layer.reducer';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {OlMapService} from 'vitojs';
import * as ol from 'openlayers';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {

  @ViewChild('search') searchTag: any;
  language = 'EN';

  searchInput: string;
  selectedLocation: any;
  keyUp = new Subject<string>();
  suggestions = [];
  showSuggestions = true;
  searchInputError = false;
  selectedIndex = -1;

  constructor(private ngRedux: NgRedux<IAppState>, private apiService: ApiService, private eRef: ElementRef, private mapService: OlMapService) {

    this.keyUp
      .map(event => this.searchInput)
      .debounceTime(300)
      .distinctUntilChanged()
      .flatMap(search => this.search())
      .subscribe(res => {
        if (res && res.features !== []) {
          this.suggestions = res.features;
        }
      });
  }

  ngOnInit() {
  }

  search() {
    this.selectedLocation = null;
    if (this.searchInput && this.searchInput.trim().length !== 0) {
      this.searchInputError = false;
      this.selectedIndex = -1;
      return this.apiService.search(this.searchInput, this.language);
    }
    this.suggestions = [];
    return Observable.of(null);
  }

  select(suggestion) {
    this.searchInputError = false;
    this.selectedLocation = suggestion;
    this.searchInput = suggestion.place_name;
    this.suggestions = [];
    this.panToLocation();
  }

  panToLocation() {
    if (this.selectedLocation) {
      this.searchInputError = false;
      const center = ol.proj.transform(this.selectedLocation.center, 'EPSG:4326', 'EPSG:3857');
      let zoom = 16;
      if (this.selectedLocation.bbox) {
        zoom = 13;
      }
      this.mapService.map.getValue().getView().animate({center: center, zoom: zoom})
      return;
    }
    this.searchInputError = true;
  }

  suggestionUp() {
    this.selectIndex(-1);
  }

  suggestionDown() {
    this.selectIndex(1);
  }

  selectIndex(val) {
    if (this.suggestions && this.suggestions.length > 0) {
      const newIndex = this.selectedIndex + val;
      if (newIndex <= 0) {
        this.selectedIndex = 0;
      } else if (newIndex >= this.suggestions.length) {
        return;
      } else {
        this.selectedIndex = newIndex;
      }
    } else {
      this.selectedIndex = -1;
    }
  }

  suggestionEnter() {
    if (this.selectedIndex !== -1 && this.suggestions && this.suggestions.length > 0) {
      this.select(this.suggestions[this.selectedIndex]);
      this.panToLocation();
    }
  }

  @HostListener('document:mousedown', ['$event'])
  handleOutsideClick(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showSuggestions = false;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/components/search/search.component.ts